import styled from 'styled-components';

export const Container = styled.section`
  padding: 45px 10px;
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

export const Logo = styled.img`
  display: block;
  margin: auto;
  margin-bottom: 45px;
`;

export const MainSection = styled.main`
  margin: auto;
  padding: 0 30px;
  max-width: 900px;
  width: 100%;
  flex: 1;
`;

export const AppointmentDetailsSection = styled.section`
  margin: 40px 0;
  padding: 30px;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

export const DetailsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

export const DetailsItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: left;
`;

export const DetailsLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #000;
`;

export const DetailsValue = styled.span`
  font-size: 16px;
  color: #333;
`;

export const GuideSection = styled.section`
  padding: 30px;
  background-color: #fff;
`;

export const ContactSection = styled.section`
  padding: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
`;

export const ButtonSection = styled.section`
  margin: 50px 0;
  display: flex;
  justify-content: center;
`;

export const Footer = styled.footer`
  margin-top: 80px;
  padding: 40px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-top: 1px solid #e5e5e5;
`;

export const FooterLogo = styled.img`
  width: 120px;
  height: auto;
`;

export const FooterText = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;
